import React from "react";

import "./style.css";
import { useEffect } from "react";
import { useInfoMutation } from "../../store/pageApi2";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from 'qrcode.react';
import { useDispatch, useSelector } from "react-redux";
import { changeXuan } from "../../store/pageSlice";
const Application = () => {
  const [info, { data: infoData }] = useInfoMutation()
  const [kong, setkong] = useState(true)
  const dispatch = useDispatch();
  const nav = useNavigate()
  const { t, i18n } = useTranslation();
  const [reference, setreference] = useState(0)
  useEffect(() => {

    dispatch(changeXuan(3))

    info({
      token: localStorage.getItem('li_token')
    }).then(res => {
      console.log(res.data.rs)
        console.log('-------rs')
        if (res.data.data.reference ) {
           setreference(res.data.data.reference)
        }
        console.log(reference)
      if (res.data.rs == -1) {
        // if (res.data.internal == 1) {
        //   setkong(false)
        // } else {
        //   setkong(true)
        // }

        //  nav('/home/information',{replace:true})
      } else if (res.data.rs === 0) {
        localStorage.removeItem('li_token')
        localStorage.removeItem('li_user_id')
        nav('/login', { replace: true })
      } else if (res.data.rs === 1) {
          console.log('-------res.data.submited'+res.data.data.submited)

          if (res.data.data.submited == 1) {
              setkong(false)

          } else {
              // if(res.data.data.type==2){
              //     setkong(false)
              // }else{
              //     setkong(true)
              // }
              setkong(true)

          }

      } else {

      }

    });
  }, [])
  const item = () => {
    return (
        <>
            <div className="group-4"  style={t('is_en') == 1 ? {marginLeft:"50px","textAlign":"center"} : {}}>

                {
                    t("is_en") == 1 ? <div className="text-wrapper-7" style={t('is_en') == 1 ? {marginLeft:"0px"} : {}}>
                            <div>You have successfully</div>
                            <div>registered for the conference.</div>
                        </div> :
                        <div className="text-wrapper-7">{t("j_tip")}</div>
                }
                <img
                    className="image"
                    alt="Image"
                    src="/img/chenggong.png"
                    style={t('is_en') == 1 ? {top:"35px"} : {}}
                />
            </div>
            <div className="overlap-wrapper">
                <div className="overlap">
                    <div className="li-wrapper">

                    </div>
                    <img src={t("is_en") == 1 ? "/img/logo-en.png" : "/img/login/logo.png"} alt="" className="logo"/>

                            <div className="text-wrapper-4">{t("理想汽车2026全球合作伙伴大会")}</div>



                    <div className="group-3">

                        {/* <img className="mask-group" src={`https://h5.aiweber.cn/images/qr/${localStorage.getItem('li_user_id')}.png?id=234`}></img> */}

                        {
                            reference ? <QRCode
                                // 指向本项目的签到台（同域，跟着部署域名走）。
                                // 原来写死 h5.aiweber.cn/lixiang/v2/，那是上一届的老系统，
                                // 它的库里没有本届的 reference，扫出来查无此人
                                value={`${window.location.origin}/checkin/${reference}`}
                                size={250} // 二维码的大小
                                fgColor="#000000" // 二维码的颜色
                                bgColor="#FFFFFF"
                                // H 级容错，现场光线差、屏幕反光时更容易扫上
                                level="H"
                                // 不放中间 logo：之前那个深色实心块以 excavate:false 直接
                                // 叠在码点上，和黑色模块混成一片，扫码器分不出明暗，扫不出来
                            /> : null
                        }

                        

                    </div>
                    <div className="text-wrapper-6"
                             style={t('is_en') == 1 ? {fontSize: '22px',marginBottom: '30px'} : {marginBottom: '30px'}}>{t("j_my_code")}</div>
                    <div className="text-wrapper-5" >{t("j_my_id")}{localStorage.getItem('li_user_id')}</div>
                    {
                        infoData ? <>

                            {
                                infoData.data.site2 ? <>
                                    <div className="text-wrapper-dahui">大会坐席：{infoData.data.site2}</div>
                                </> : <div className="text-wrapper-dahui">大会坐席：自由入座</div>
                            }
                            {
                                infoData.data.site3 ? <>
                                    <div className="text-wrapper-wanyan">晚宴位置：{infoData.data.site3}</div>
                                </> : <div className="text-wrapper-dahui">晚宴位置：自由入座</div>
                            }


                        </> : null
                    }
                </div>
                <div className="shuoming">
                    {/* {t("shuoming")} */}

                </div>

            </div>

            <div className="group-wrapper">
                <div className="group-2" >
                    <div className="text-wrapper-2">{t("j_my_intro")}</div>
                    <div className="text-wrapper-3" style={t('is_en') == 1 ? {fontSize: '23px'} : {fontSize: '26px'}}>


                        <div className="zhushi">
                            <div style={{width: '30px'}}>1.&nbsp;</div>
                            <div>{t("说明1")}</div>
                        </div>
                        <div className="zhushi">
                            <div style={{width: '30px'}}>2.&nbsp; </div>
                            <div>{t("说明2")}</div>
                        </div>
                        <div className="zhushi">
                            <div style={{width: '30px'}}>3.&nbsp; </div>
                            <div>{t("说明3")}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
  }
    return (
        <div className="application">
            <div className="div">


                {
                    kong ? <>
                        <>
                            <div className="group" >

                            </div>
                            <div className="overlap-wrapper">
                                <div className="overlap">
                                    <div className="li-wrapper">

                                    </div>
                                    <img src="/img/login/logo.png" alt="" className="logo"/>

                                    {/*{*/}
                                    {/*    t('is_en') == 1 ?*/}
                                    {/*        <img src="/img/8-28-title.png" alt="" className="text-wrapper-4"/> :*/}
                                    {/*}*/}
                                    <div className="text-wrapper-4">{t("理想汽车2026年全球合作伙伴大会")}</div>
                                    <button className="group-baoming" onClick={() => {
                                        dispatch(changeXuan(2))
                                        nav('/home/information', {replace: true});

                                    }}>

                                        {t("您未报名")}
                                    </button>
                                </div>
                            </div>
                            <div className="group-4">

              </div>
              {/* <div className="group-wrapper">
                <div className="group-2">
                  <div className="text-wrapper-2">
                    {t("j_my_intro")}
                  </div>
                  <div className="text-wrapper-3">
                    {t("j_my_intro_desc")}

                  </div>
                </div>
              </div> */}
            </>
          </> : item()
        }
                {/*{*/}
        {/*            item()*/}
        {/*        }*/}
      </div>
    </div>
  );
};

export default Application